import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class EnrollmentAcceptedStudentService {

  constructor(private http: HttpClient) { }

  // getAcceptedCandidates(username: string, fieldName?: string, orderType?: string) {
  //   return this.http.get<any>(
  //     `${environment.API_URL_ADM}/api/erlsemesterstudentdtl/`);
  // }

  getAcceptedCandidates(username: string, fieldName?: string, orderType?: string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlsemesterstudentdtlvw/`);
  }


  getAcceptedCandidatesOrderBy(username: string, fieldName: string, orderType: string) {
    // http://localhost/api/erlsemesterstudentdtlsortby/{fieldName}/{A or D}
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlsemesterstudentdtlsortby/${fieldName}/${orderType}`);
  }

  getLastMatNumber(orgid: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/getlastmatno/${orgid}`);
  }

  reloadAcceptedCandidatesAndResetOrder(username: string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/loadnewenrolledcandidates/RELOAD/${username}`);
  }

  getNewlyAcceptedCandidates(username: string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/loadnewenrolledcandidates/SYNCH/${username}`);
  }

  saveSemesterNewCandsEnrollment(org: number, year: number, semesterId: number, username: string) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/finalizeenrollment/${org}/${year}/${semesterId}/${username}`);
  }

  updateAcceptedStudent(username: string, student: any) {
    // Delete numbering from student object
    delete student.no;
    return this.http.put<any>(
      `${environment.API_URL_ADM}/api/erlsemesterstudentdtl/${username}/${student.id}`, student);
  }

  getEnrollmentHeader(org: number, year: number, semesterId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlgetenrollmentheader/${org}/${year}/${semesterId}`);
  }

  getStudentStatuses() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/stustudentstatuses`);
  }

  getStudentByCodeOrName(org: number, codeOrName: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/stustudentbycode/${org}/${codeOrName}`);
  }

  getStudentByCode(org: number, code: any) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/stustudentbycode/${org}/${code}`);
  }

  deleteStudentSubjectById(id: number) {
    return this.http.delete<any>(
      `${environment.API_URL_ADM}/api/erlstudentsubjects/${id}`);
  }

  getGradeBySubjectId(orgId: number, subjectId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/acmsubjectgrade/${orgId}/${subjectId}`);
  }

  addStudentSubjectRepeater(username: string, subjectInfo: any) {
    return this.http.post<any>(
      `${environment.API_URL_ADM}/api/erlstudentsubjects/${username}`, {...subjectInfo});
  }

  getStudentRepeaterSubjects(orgId: number, yearId: number, semesterCode: number, studId: number) {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlstudentsubjectsbystudentfull/${orgId}/${yearId}/${semesterCode}/${studId}`);
  }

  getAllEelStudentStatus() {
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/erlstudentsubjectstatus/`);
  }
  getAllStudents(){
    return this.http.get<any>(
      `${environment.API_URL_ADM}/api/stustudents/`);
  }

}
